// extracted by mini-css-extract-plugin
export default {"host":"style_host__truz4","iconApproved":"style_iconApproved__dAzHk"};